import { render } from "./Linda_page3.vue?vue&type=template&id=107bb363&scoped=true"
import script from "./Linda_page3.vue?vue&type=script&lang=js"
export * from "./Linda_page3.vue?vue&type=script&lang=js"

import "./Linda_page3.vue?vue&type=style&index=0&id=107bb363&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107bb363"]])

export default __exports__